export default {
  CMS_ADMIN_LOAD_TREE_COMPONENTS: "CMS_CONTRIB_CMS_COMPONENTS_TREE::REFRESH",

  CMS_CONTRIB_DMS_MANAGEMENT_REFRESH_TREE: "CMS_CONTRIB_CMS_DMS_MANAGEMENT_TREE::REFRESH",
  CMS_CONTRIB_DMS_MANAGEMENT_REFRESH_FILES: "CMS_CONTRIB_CMS_DMS_MANAGEMENT_FILES::REFRESH",
  CMS_CONTRIB_SITEMAP_REFRESH_TREE: "CMS_CONTRIB_CMS_SITEMAP_TREE::REFRESH",
  CMS_CONTRIB_HTML_CONTENT_ON_CHANGE_DATA: "CMS_CONTRIB_DYNAMIC_HTML_CONTENT_ON_CHANGE_DATA",

  CMS_CONTRIB_ARTICLE_CONFIG_REFRESH: "CMS_CONTRIB_ARTICLE_CONFIG::REFRESH",

  CMS_OVERLAY_SHOW: "CMS_OVERLAY::SHOW",
  CMS_OVERLAY_HIDE: "CMS_OVERLAY::HIDE",

  CMS_MODAL_TEMPLATE_TITLE_CHANGE: "CMS_MODAL_TEMPLATE::TITLE_CHANGE",
};
